import React, { useState, useEffect } from 'react';
import { Page, Dashboard, ReflexHorizontalContainer } from '../../templates';
import { Content } from '../../organisms';
import { DataGridPremium } from '@mui/x-data-grid-premium';
import { FlexBoxVertical, FlexBox, ToggleSwitch, FlexBoxHorizontal, BackdropPanel, Label, Button } from '../../atoms';
import { LanguageButton, InfoTooltip, SelectAllCheckBox } from '../../molecules';
import i18n from '../../../utils/i18n';
import { useTranslation } from 'react-i18next';
import IconButton from '@mui/material/IconButton';
import { Paper, Box, Typography, TextField, Avatar } from '@mui/material';
import SendIcon from '@mui/icons-material/Send';
import CloseIcon from '@mui/icons-material/Close';
import TestReportFilter from './Filter';
import { FaWandMagicSparkles } from "react-icons/fa6";
import SystemUpdateAltIcon from '@mui/icons-material/SystemUpdateAlt';
import LinearProgress from '@mui/material/LinearProgress';
import Draggable from 'react-draggable';
import palette from '../../../utils/colorPalette';

const ChatPanel = ({ onClose, selectedFile }) => {
  const [message, setMessage] = useState('');
  const [messages, setMessages] = useState([]);

  const handleSendMessage = () => {
    if (message.trim()) {
      setMessages([...messages, { text: message, sender: 'user' }]);
      setMessage('');
    }
  };

  return (
    <Draggable
      handle=".drag-handle"
      defaultPosition={{x: 0, y: 0}}
      grid={[1, 1]}
    >
      <Paper 
        elevation={3} 
        sx={{ 
          width: '400px', 
          height: '70%', 
          position: 'relative',
          display: 'flex',
          flexDirection: 'column',
          backgroundColor: '#fff',
          borderRadius: '10px',
          overflow: 'hidden',
      //     cursor: 'move',
          boxShadow: '0 4px 8px rgba(0,0,0,0.2)'
        }}
      >
        {/* 헤더 */}
        <Box 
          className="drag-handle"
          sx={{ 
            p: 2, 
            borderBottom: '1px solid #e0e0e0',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            backgroundColor: palette.button.primary,
            color: '#fff',
            cursor: 'move',
            userSelect: 'none'
          }}
        >
          <Typography sx={{ 
            fontSize: '14px',
            fontWeight: 600,
            display: 'flex',
            alignItems: 'center',
            gap: 1
          }}>
            {selectedFile.orgn_file_nm}
          </Typography>
          <IconButton onClick={onClose} size="small" sx={{ color: '#fff' }}>
            <CloseIcon />
          </IconButton>
        </Box>

        {/* 메시지 영역 */}
        <Box sx={{ 
          flex: 1, 
          overflowY: 'auto',
          p: 2,
          display: 'flex',
          flexDirection: 'column',
          gap: 2,
          backgroundColor: '#f8f9fa',
          '&::-webkit-scrollbar': {
            width: '6px',
          },
          '&::-webkit-scrollbar-track': {
            background: '#f1f1f1',
          },
          '&::-webkit-scrollbar-thumb': {
            background: '#888',
            borderRadius: '3px',
          },
        }}>
          {messages.map((msg, index) => (
            <Box
              key={index}
              sx={{
                alignSelf: msg.sender === 'user' ? 'flex-end' : 'flex-start',
                maxWidth: '80%',
                animation: 'fadeIn 0.3s ease-in-out',
                '@keyframes fadeIn': {
                  '0%': { opacity: 0, transform: 'translateY(10px)' },
                  '100%': { opacity: 1, transform: 'translateY(0)' }
                }
              }}
            >
              <Paper
                elevation={1}
                sx={{
                  p: 1.5,
                  backgroundColor: msg.sender === 'user' ? '#1976d2' : '#ffffff',
                  color: msg.sender === 'user' ? '#fff' : '#000',
                  borderRadius: '16px',
                  boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                  position: 'relative',
                  '&::before': {
                    content: '""',
                    position: 'absolute',
                    top: '50%',
                    [msg.sender === 'user' ? 'right' : 'left']: '-8px',
                    transform: 'translateY(-50%)',
                    borderStyle: 'solid',
                    borderWidth: '8px',
                    borderColor: msg.sender === 'user' 
                      ? '#1976d2 transparent transparent transparent'
                      : '#ffffff transparent transparent transparent'
                  }
                }}
              >
                <Typography variant="body1" sx={{ fontSize: '14px', lineHeight: 1.5 }}>
                  {msg.text}
                </Typography>
              </Paper>
            </Box>
          ))}
        </Box>

        {/* 입력 영역 */}
        <Box sx={{ 
          p: 2, 
          borderTop: '1px solid #e0e0e0',
          display: 'flex',
          gap: 1,
          backgroundColor: '#fff'
        }}>
          <TextField
            fullWidth
            variant="outlined"
            size="small"
            placeholder="챗 기능 개발 중입니다.(Coming Soon)"
            value={message}
            onChange={(e) => setMessage(e.target.value)}
            onKeyPress={(e) => {
              if (e.key === 'Enter') {
                handleSendMessage();
              }
            }}
            sx={{
              '& .MuiOutlinedInput-root': {
                borderRadius: '24px',
                backgroundColor: '#f8f9fa',
                '&:hover': {
                  backgroundColor: '#f0f2f5'
                }
              }
            }}
          />
          <IconButton 
            color="primary" 
            onClick={handleSendMessage}
            disabled={!message.trim()}
            sx={{
              backgroundColor: '#1976d2',
              color: '#fff',
              '&:hover': {
                backgroundColor: '#1565c0',
              },
              '&.Mui-disabled': {
                backgroundColor: '#e0e0e0',
                color: '#fff'
              }
            }}
          >
            <SendIcon />
          </IconButton>
        </Box>
      </Paper>
    </Draggable>
  );
};

export default ChatPanel;